import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../contexts/LanguageContext';

const ToggleButton = styled.button`
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 8px 16px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 3rem;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <ToggleButton
      onClick={() => setLanguage(language === 'en' ? 'fr' : 'en')}
      aria-label={language === 'en' ? 'Switch to French' : 'Switch to English'}
    >
      {language === 'en' ? 'FR' : 'EN'}
    </ToggleButton>
  );
};

export default LanguageToggle; 